import { DetailsVisibilityTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import DocumentsDetailTab from './tabs/DocumentsDetailsTab';
import DocumentsUserFolders from './tabs/DocumentsUserFolders';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <DocumentsDetailTab {...props} />
	},
	{
		id: 'visibility',
		title: 'TAB_VISIBILITY',
		content: ({ model }) => <DetailsVisibilityTab module="sys_documents_folders" model={model} />,
		disabled: ({ isEdit }) => isEdit
	},
	{
		id: 'folders',
		title: 'TAB_USERS_FOLDERS',
		hidden: ({ model }) => !model.fold_personal,
		content: ({ model }) => <DocumentsUserFolders folderUid={model.fold_uid} />,
		disabled: ({ isEdit }) => isEdit
	}
];

export default tabs;
